import MainRoutes from './routes/mainRoutes';

function App() {
  return <MainRoutes />
}

export default App;
